import { AddToCartButton } from "@shopify/hydrogen-react";

type AddToCartProps = {
  variantId: string;
  quantity?: number;
};

function AddToCart({ variantId, quantity = 1 }: Partial<AddToCartProps>) {
  if (!variantId) {
    return null;
  }

  return (
    <AddToCartButton variantId={variantId} quantity={quantity}>
      Add to Cart
    </AddToCartButton>
  );
}

export { AddToCart };
